import macy from "macy";

export default {macy}
